<script setup lang="ts">
import type { ProductDocument } from "@/schemas/product-document";

defineProps<{ product: ProductDocument }>();
</script>

<template>
  <div class="h3 text-primary">
    {{ currency(product.price) }}
  </div>
  <div v-if="product.on_sale && product.sale_price">
    Prix régulier: <span class="line-through">{{ currency(product.regular_price) }}</span>
  </div>
  <div>
    Prix de détail suggéré: {{ currency(product.msrp_price) }}
  </div>
</template>
